var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fd-product-tile',{attrs:{"is-button":"","title":"For Sale – a wonderful vineyard","url":_vm.$withBase('images/product-tile/product.jpeg')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }